var scope_0 = require('/home/runner/work/www.fyianlai.com/www.fyianlai.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/18f59562e75bc6268f4e1c5f34c9c72f.js').default;
var scope_1 = require('/home/runner/work/www.fyianlai.com/www.fyianlai.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    